import { isArray } from 'lodash';
import * as React from 'react';
import { Message } from 'semantic-ui-react';

interface IBPFormErrorProps {
    errors: {},
    touched: {},
    isValid: boolean,
}

export const BPFormError: React.FunctionComponent<IBPFormErrorProps> = (props) => {
    return <Message visible={!props.isValid && Object.keys(props.errors).length > 0} error>
        <Message.Header>
            {window.translation.common.errorsOnForm}
        </Message.Header>
        <Message.Content>
            {/* {JSON.stringify(Object.keys(props.errors))} */}
            {Object.keys(props.errors)
                .filter(key => props.errors[key] != '')
                // .filter(key => typeof props.errors[key] == 'string')
                .map(key => {
                    const err = errorFromObj(props, key)
                    return err == '' ? null : (
                        <Message.Item key={key}>
                            {err}
                        </Message.Item>
                    )
                })}
        </Message.Content>
    </Message>;
};

export function errorFromObj(props, key) {
    if (props?.errors == null)
        return '';
    return isArray(props.errors[key]) ? props.errors[key].join(" ") : typeof props.errors[key] == 'object' ? "" : props.errors[key]
}
